import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { API_URL } from "../../../utils/Common";
import ButtonIconLink from "../../sharecomponents/ButtonIconLink";
import MyLoader from "../../sharecomponents/MyLoader";
import Modal from "../../sharecomponents/Modal";

const CatalogoRanchos = (props) => {
   const modalRef = useRef();
   const [ranchos, updateRanchos] = useState([]);
   const [loader, updateLoader] = useState(false);
   const [ranchoSelect, setRanchoSelect] = useState({});

   useEffect(() => {
      getRanchos();
   }, []);

   const getRanchos = () => {
      updateLoader(true);
      axios.get(API_URL + "/rancho/getRanchos").then((r) => {
         console.log(r.data);
         updateRanchos(r.data.ranchos);
         updateLoader(false);
      });
   };

   const goAltaRancho = () => {
      props.history.push("/ranchos_alta");
   };

   const remover = () => {
      console.log(ranchoSelect);
      updateLoader(true);
      axios
         .delete(API_URL + "/removerRancho", { params: { id: ranchoSelect.id } })
         .then((r) => {
            console.log(r.data);
            modalRef.current.hideModal();
            getRanchos();
            updateLoader(false);
         })
         .catch((e) => console.log(e));
   };

   return (
      <div className="w-full p-3">
         <div className="bg-white border rounded shadow">
            <div className="border-b rounded-t p-3 bg-orange-900">
               <h5 className="font-bold uppercase text-white">Ranchos Registrados</h5>
            </div>
            <div className="p-5 rounded-b">
               {/* ---- CONTENIDO --- */}
               <div className="inline-flex">
                  <button
                     className="bg-orange-800 hover:bg-orange-700 text-white py-1 px-4 mr-5 rounded shadow-lg focus:outline-none"
                     onClick={goAltaRancho}
                  >
                     <i className="fas fa-plus mr-3" /> Registrar Rancho
                  </button>
               </div>
               <table className="table-auto mt-5 w-full">
                  <thead>
                     <tr className="border border-orange-800 text-xs text-white content-center bg-orange-800">
                        <th className="px-4 py-2">Nombre del Rancho</th>
                        <th className="px-4 py-2">No. Válvulas</th>
                        <th className="px-4 py-2">Acciones</th>
                     </tr>
                  </thead>
                  <tbody>
                     {ranchos.length > 0 &&
                        ranchos.map((r, i) => {
                           return (
                              <tr key={i} className="text-sm">
                                 <td className="border px-4 py-2 uppercase">{r.nombre}</td>
                                 <td className="w-40 border px-4 py-2 text-center">{r.valvulas.length}</td>
                                 <td className="w-40 border px-4 py-2 text-center">
                                    <ButtonIconLink
                                       iconClass="fas fa-info-circle"
                                       disabled={false}
                                       history={props.history}
                                       to={"info_rancho/" + r.id}
                                    />
                                    <button
                                       className="text-xs bg-blue-700 hover:bg-blue-600 text-white font-bold py-2 px-3 rounded m-1 focus:outline-none"
                                       onClick={() => {
                                          setRanchoSelect(r);
                                          modalRef.current.showModal();
                                       }}
                                    >
                                       <i className="fas fa-trash" />
                                    </button>
                                    {/*<ButtonIconLink
                                       iconClass="fas fa-trash"
                                       disabled={true}
                                       history={props.history}
                                       to=""
                                    />*/}
                                 </td>
                              </tr>
                           );
                        })}
                  </tbody>
               </table>
            </div>
         </div>
         {loader && <MyLoader />}
         <Modal
            titulo="Remover Rancho"
            mensaje={`¿Seguro de Remover el Rancho ${ranchoSelect.nombre}?`}
            ref={modalRef}
            actionTitle="Remover"
            actionFn={remover}
         />
      </div>
   );
};

export default CatalogoRanchos;
